import React, { Children, useContext, cloneElement } from 'react';
import { UIContext } from 'context/ui';
import { FormattedMessage } from 'react-intl';

import { Container } from 'components/layout/Container';

import Chevron from 'assets/svg/icons/chevron.svg';

import s from './Tabs.scss';

interface IProps {
  children: React.ReactNode;
  fluid?: boolean;
  className?: string;
  onUpdate?: (args: any) => void;
  onClick?: (id: string) => void; // will override update behaviour
  location?: { pathname: string; };
  loading?: boolean;
}

export const Tabs = ({ location, children, onClick, onUpdate, loading }: IProps) => {
  const { isDesktop } = useContext<any>(UIContext);

  const update = (id: string) => {
    if (location) {
      const postfix = id ? `?q=${id}` : '';
      window.history.pushState({}, '', `${location.pathname}${postfix}`);
    }

    if (onUpdate) {
      onUpdate(id);
    }
  };

  const onChange = (event: React.FormEvent<HTMLSelectElement>) => {
    update(event.currentTarget.value);
  };

  const content = !isDesktop ? (
    <div className={s('tabs', { loading })}>
      <FormattedMessage id="filter-articles">
        {(ariaLabel) =>
          <select className={s.tabs__select} onChange={onChange} aria-label={ariaLabel as string}>
            {children}
          </select>
          }
       </FormattedMessage>
      <Chevron className={s.tabs__chevron} />
    </div>
  ) : (
    <ul className={s('tabs', { loading })}>
      {Children.map(children, (child, i) => (
          <li className={s.tabs__item} key={`${s.tabs}-${i}`}>
            {child && cloneElement(child as React.ReactElement<any>, {
              onClick: onClick ? onClick : update,
            })}
          </li>
        ))}
    </ul>
  );

  return (
    <Container>
      {content}
    </Container>
  );
};
